import type { AxiosInstance } from 'axios';
import axios from 'axios';
import { getDeviceId } from 'helpers/tokenManager';
import { getLanguageCode } from 'helpers/translationHelper';

const createApiClient = (apiRoot: string): AxiosInstance => {
  const axiosInstance = axios.create();
  axiosInstance.defaults.timeout = 15000;

  axiosInstance.interceptors.request.use((cfg) => {
    const paramConfig = cfg;

    paramConfig.headers.set('deviceId', getDeviceId());
    paramConfig.headers.set('X-Accept-ProblemDetails', true);
    paramConfig.headers.set('Accept-Language', getLanguageCode() ?? 'cs');

    paramConfig.baseURL = apiRoot;

    return paramConfig;
  });

  return axiosInstance;
};

export default createApiClient;
